import * as angular from 'angular';
import * as _ from 'lodash';
import * as $ from 'jquery';

import { PropertyType, IGroupTreeNode, ComponentDefinition, BulkEditProperty, Identifier, IValueViewModel,IdentifierDumbTableRowButton, IDisplayedColumn } from '../../../models';
import { ILoggerService, IIdentifierVmService, IGroupService } from '../../../services';
import { identifierSavedForce, isEditMode } from '../../../common/events';
import { IRootScope } from '../../../IRootScope';

class IdentifiersPageController implements angular.IComponentController {
    bulkEditProperties: BulkEditProperty[];
    displayed: Identifier[];
    identifierButtons: IdentifierDumbTableRowButton[];
    isEditMode: boolean;
    isLoading: boolean;
    menu: IDisplayedColumn[];
    selectedGroup: IGroupTreeNode;

    readonly selectedIdentifier: Identifier;
    readonly selectedViewModel: IValueViewModel;

    private _unsubscribe: () => void;

    static $inject = [
        '$rootScope',
        'identifierVmService',
        'groupService',
        'loggerService'
    ];

    constructor(
        private _$rootScope: IRootScope,
        private _identifierVmService: IIdentifierVmService,
        private _groupService: IGroupService,
        private _loggerService: ILoggerService
    ) {
    }

    $onInit() {
        this.menu = [
            { isVisible: true, property: 'name', type: 'name', label: 'Name' },
            { isVisible: true, property: 'tagName', type: 'tag', label: 'Tag/Identifier' },
            { isVisible: false, property: 'groupAbsolutePath', type: 'groupAbsolutePath', label: 'Group Absolute Name' },
            { isVisible: true, property: 'groupUniqueName', type: 'groupUniqueName', label: 'Group' },
            { isVisible: true, property: 'shortComment', type: 'shortComment', label: 'Short comment' },
            { isVisible: false, property: 'longComment', type: 'longComment', label: 'Long comment' },
            { isVisible: false, property: 'documentation', type: 'documentation', label: 'Documentation' },
            { isVisible: true, property: 'variableTypeName', type: 'type', label: 'Type' },
            { isVisible: true, property: 'variableSubTypeName', type: 'subtype', label: 'Subtype' },
            { isVisible: true, property: 'qualifierName', type: 'qualifier', label: 'Qualifier' },
            { isVisible: true, property: 'unitName', type: 'unit', label: 'Unit' },
            { isVisible: true, property: 'target', type: 'target', label: 'Target' },
            { isVisible: false, property: 'pfd', type: 'pfd', label: 'PFD' },
            { isVisible: false, property: 'pid', type: 'pid', label: 'PID' },
            { isVisible: false, property: 'dataSheet', type: 'dataSheet', label: 'Data sheet' },
            { isVisible: false, property: 'defaultValue', type: 'defaultValue', label: 'Default value' },
            { isVisible: false, property: 'min', type: 'min', label: 'Min' },
            { isVisible: false, property: 'max', type: 'max', label: 'Max' },
            { isVisible: false, property: 'stdDevThreshold', type: 'stdDevThreshold', label: 'Std dev threshold' },
            { isVisible: false, property: 'flatMode', type: 'flat', label: 'Flat' },
            { isVisible: false, property: 'resolution', type: 'resolution', label: 'Resolution' },
            { isVisible: false, property: 'resolutionPercentage', type: 'resolutionPercentage', label: 'Resolution%' },
            { isVisible: false, property: 'source', type: 'source', label: 'Source' },
            { isVisible: false, property: 'sortingOrder', type: 'sortingOrder', label: 'Sorting order' },
            { isVisible: false, property: 'customProperties', type: 'customProperties', label: 'Own fields' }
        ];

        const bulkEditProperties: BulkEditProperty[] = [
            { key: 'Name', value: 'Name', type: PropertyType.Text },
            { key: 'ShortComment', value: 'Short comment', type: PropertyType.Text },
            { key: 'LongComment', value: 'Long comment', type: PropertyType.Text },
            { key: 'Documentation', value: 'Documentation', type: PropertyType.Text },
            { key: 'Target', value: 'Target', type: PropertyType.Number },
            { key: 'DefaultValue', value: 'Default value', type: PropertyType.Number },
            { key: 'Min', value: 'Min', type: PropertyType.Number },
            { key: 'Max', value: 'Max', type: PropertyType.Number },
            { key: 'DefaultValue', value: 'DefaultValue', type: PropertyType.Number },
            { key: 'Resolution', value: 'Resolution', type: PropertyType.Number },
            { key: 'ResolutionPercentage', value: 'Resolution%', type: PropertyType.Number },
            { key: 'AggregationMode', value: 'Aggregation mode', type: PropertyType.AggregationMode },
            // Variable type not included due to story #20994
            { key: 'VariableSubTypeGuid', value: 'Variable subtype', type: PropertyType.VariableSubType, onlyMatching: true },
            { key: 'QualifierGuid', value: 'Qualifier', type: PropertyType.Qualifier, onlyMatching: true },
            { key: 'UnitGuid', value: 'Unit', type: PropertyType.Unit, onlyMatching: true },
            { key: 'VariablesAndUnit', value: 'Variable and unit', values: ['Variable subtype', 'Qualifier', 'Unit'], type: PropertyType.VariablesAndUnit, onlyNotMatching: true }
        ];
        this.bulkEditProperties = _.sortBy(bulkEditProperties, v => v.value);
        this.isEditMode = this._$rootScope.isEditMode;
        this._unsubscribe = this._$rootScope.$on(isEditMode, () => this.isEditMode = this._$rootScope.isEditMode);
        this.identifierButtons = [{
            callback: () => $('#identifierUsageModal').modal('show'),
            getClasses: vm => 'fa fa-fw fa-search ' + (vm.canDelete ? 'grey disabled' : 'button'),
            title: 'Usage'
        }];
    }

    $onDestroy() {
        this._unsubscribe();
    }

    onBulkEdit(data: number) {
        this._loggerService.logSuccess(`${data} properties updated.`);
        this._identifierVmService.cleanCompleteCache();
        this._groupService.cleanGroupCache();
        this._$rootScope.$broadcast(identifierSavedForce);
    }
}

export const wtIdentifiersPage: ComponentDefinition = {
    componentId: 'wtIdentifiersPage',
    controller: IdentifiersPageController,
    template: require('./identifiersPage.component.html'),
    controllerAs: 'vm',
    bindings: {
        selectedIdentifier: '<',
        selectedViewModel: '<'
    }
};